var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTutorialsProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 25.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#bdccd4;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-tutorials-progress") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.19,5.86H29.06A.94.94,0,0,0,30,4.92V2.58a.94.94,0,0,0-.94-.94H12.19a.94.94,0,0,0-.94.94V4.92A.94.94,0,0,0,12.19,5.86Zm0,9.37H29.06A.94.94,0,0,0,30,14.3V12a.94.94,0,0,0-.94-.94H12.19a.94.94,0,0,0-.94.94V14.3A.94.94,0,0,0,12.19,15.24Zm0,9.37H29.06a.94.94,0,0,0,.94-.94V21.33a.94.94,0,0,0-.94-.94H12.19a.94.94,0,0,0-.94.94v2.34A.94.94,0,0,0,12.19,24.61ZM3.75,19.69a2.81,2.81,0,1,0,0,5.62,2.81,2.81,0,1,0,0-5.62ZM9.17,2.17,4.94,6.4,4,7.31a.75.75,0,0,1-1,0L.21,4.54a.7.7,0,0,1,0-1l.92-.92a.7.7,0,0,1,1,0L3.45,3.92,7.18.21a.7.7,0,0,1,1,0l1,1A.71.71,0,0,1,9.17,2.17Zm0,9.35L4.94,15.75,4,16.67a.75.75,0,0,1-1,0L.21,13.89a.7.7,0,0,1,0-1L1.13,12a.7.7,0,0,1,1,0l1.33,1.29L7.18,9.53a.7.7,0,0,1,1,0l1,1a.7.7,0,0,1,0,1Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTutorialsProgress);
export default __webpack_public_path__ + "static/media/icon-tutorials-progress.b0fdf7bb6b6a2028574e9fbe2fd223e9.svg";
export { ForwardRef as ReactComponent };